<template>
  <div class="app-container">
    <div v-if="key == '/energy/index'">
    <div
      style="margin-bottom: 10px; display: flex; justify-content: space-between"
    >
      <div class="screenBox">
        <el-input
          class="screenInput"
          v-model="screen.file_name"
          placeholder="请输入账单名称"
        ></el-input>
        <el-date-picker
          class="screenInput"
          v-model="screen.date"
          type="date"
          :value-format="timestamp"
          placeholder="选择上传日期"
        >
        </el-date-picker>
        <el-button type="primary" @click="(screen.page = 1), fetchData()"
          >筛选</el-button
        >
        <el-button type="primary" plain @click="chongZhi()">重置</el-button>
      </div>
      <el-button
        size="medium"
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/company_user/import_user')"
        >导入</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="id" label="ID" width="100"> </el-table-column> -->
      <el-table-column label="账单名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.file_name }}
        </template>
      </el-table-column>
      <el-table-column label="上传时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="roles.includes('/energy/bill_review')"
            size="mini"
            type="warning"
            @click="toDetails(scope.row.id)"
            >预览账单</el-button
          >
           <el-button
            v-if="roles.includes('/energy/download_primitive_table')"
            size="mini"
            type="info"
            @click="downloadPrimitive(scope.row.id)"
            >导出账单</el-button
          >
          <el-button
            v-if="roles.includes('/energy/import_del')"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/energy/import'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccessFile"
        :on-progress="beforeAvatarUploadFile"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        > -->
      </div>
    </el-dialog>
    </div>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
import {
  energy_import_lists,
  energy_import_del,
  bill_review,
  download_primitive_table
} from "@/api/energy";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
    key() {
      return this.$route.path;
    },
  },
  data() {
    return {
      timestamp: "yyyy-MM-dd",
      token: getToken(),
      total: 0,
      list: [],
      listLoading: true,
      screen: {
        page: 1,
        page_size: 15,
        file_name: "",
        date: "",
      },
      multipleSelection: [],
      loadProgress: 0,
      progressFlag: false,
      ossUpload: this.$store.state.ossUpload,
      baseURL: this.$store.state.baseURL,
      leadInVisible: false,
      msgData: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 导出账单
  downloadPrimitive(id){
    console.log(id)
    const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
        let data = {
          id:id
        }
      download_primitive_table(data).then((res) => {
        console.log(res)
        loading.close();
        let downloadElement = document.createElement("a");
       let href = res.data.url; //创建下载的链接
             const fileName = href.substring(href.lastIndexOf('/') + 1);
             console.log(fileName)
          downloadElement.href = href;
          downloadElement.download = fileName;
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        loading.close();
      });
  },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        file_name: "",
        date: "",
      };
      this.fetchData();
    },
    toDetails(id) {
      this.$router.push({
        path: "/energy/index/details",
        query: { energyId: id },
      });
    },

    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccessFile(res, file) {
      const loading = this.$loading({
        lock: true,
        text: "上传中，请稍后。。。",
        spinner: "el-icon-loading",
      });
      if (res.code === 200) {
        loading.close();
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        loading.close();
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUploadFile(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },

    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 删除
    handleDelete(val) {
      const data = {
        id: val.id,
      };
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          energy_import_del(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
            // that.openUserRole(val.user_id);
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    fetchData() {
      this.listLoading = true;
      energy_import_lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}

.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 5px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
